<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mx-auto mt-1 relative">
        <!-- Loading Overlay -->
        <div v-if="loading" class="absolute inset-0 bg-gray-50 bg-opacity-75 flex items-center justify-center rounded z-50">
          <div class="text-center">
            <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
            <p class="mt-2 text-sm text-gray-600">Loading...</p>
          </div>
        </div>

        <div class="col-span-12 mx-auto mt-1">
          <div class="grid grid-cols-12 gap-4 mx-1 py-1">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.country?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.region?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.district?.name?.toLowerCase() || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.subcounty?.name || ''"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.parish?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.village?.village?.name || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.plot || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.street || ''"
                  required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                  id="companyName"
                  
                  
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.postalAddress || ''"
                  required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <textarea
                  id="companyName"
                  class="form-text text-sm noFocus text-capitalize"
                  rows="4"
                  disabled="true"
                  :value="getCompanyAddress?.data?.address?.description || ''"
                  required>
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";

const props = defineProps<{ brn: string }>();

const fileStore = useBusinessFileStore();

const loading = ref(true);

const getCompanyAddress = computed(() => fileStore.address);

onMounted(() => {
  fileStore.fetchCompanyAddress(props.brn);
});

watch(() => fileStore.address, () => {
  loading.value = false;
});
</script>

